import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PublicOnly, RequireAuth, RequireAdmin } from '@/auth/guards';
import { AppShell } from '@/layouts/AppShell';

import LoginPage from '@/pages/LoginPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import DashboardPage from '@/pages/DashboardPage';
import CplListPage from '@/pages/cpl/CplListPage';
import CplFormPage from '@/pages/cpl/CplFormPage';
import JacketListPage from '@/pages/jacket/JacketListPage';
import JacketFormPage from '@/pages/jacket/JacketFormPage';
import RatePage from '@/pages/rate/RatePage';
import AccountPage from '@/pages/AccountPage';
import { AdminLayout } from '@/pages/admin/AdminLayout';
import AdminUsersPage from '@/pages/admin/AdminUsersPage';
import AdminUserFormPage from '@/pages/admin/AdminUserFormPage';
import AdminReportPage from '@/pages/admin/AdminReportPage';
import NotFoundPage from '@/pages/NotFoundPage';

export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public — login is sign-in-only; the rate calculator is open to anyone
            (no auth), though its backend endpoint is still CSRF-protected. */}
        <Route element={<PublicOnly />}>
          <Route path="/login" element={<LoginPage />} />
        </Route>
        {/* Reset link from a recovery email — reachable whether or not signed in. */}
        <Route path="/reset" element={<ResetPasswordPage />} />
        <Route path="/rate" element={<RatePage />} />

        {/* Authenticated app */}
        <Route element={<RequireAuth />}>
          <Route element={<AppShell />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/cpls" element={<CplListPage />} />
            <Route path="/cpls/new" element={<CplFormPage />} />
            <Route path="/cpls/:id/edit" element={<CplFormPage />} />
            <Route path="/jackets" element={<JacketListPage />} />
            <Route path="/jackets/new" element={<JacketFormPage />} />
            <Route path="/jackets/:id/edit" element={<JacketFormPage />} />
            <Route path="/account" element={<AccountPage />} />

            {/* Admin (role 2 only) */}
            <Route element={<RequireAdmin />}>
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminUsersPage />} />
                <Route path="report" element={<AdminReportPage />} />
              </Route>
              <Route path="/admin/users/new" element={<AdminUserFormPage />} />
              <Route path="/admin/users/:id/edit" element={<AdminUserFormPage />} />
            </Route>
          </Route>
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}
